package com.cybersoftsolution.cybersoftsolutionweb.models


import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.rgb
import org.jetbrains.compose.web.css.rgba

enum class Theme (
    var hex: String,
    var rgb: CSSColorValue
){
    PrimaryButton (
        hex = "#ffcd57",
        rgb = rgb(r = 255, g = 205, b = 87)
    ),
    PrimaryButtonLight(
        hex = "#fff3e0",
        rgb = rgb(r = 255, g = 243, b = 224)
    ),
    LightGray(
        hex = "#efefef",
        rgb = rgb(r = 239, g = 239, b = 239)
    ),
    LightDarkGray(
        hex = "#efefef",
        rgb = rgb(r = 225, g = 225, b = 225)
    ),
    DarkGray(
        hex = "#a9a9a9",
        rgb = rgb(r = 169, g = 169, b = 169)
    ),
    HalfWithe(
        hex = "#ffffff",
        rgb = rgba(r = 255, g = 255, b = 255, a = 0.5)
    ),
    HalfBlack(
        hex = "#000000",
        rgb = rgba(r = 0, g = 0, b = 0, a = 0.5)
    ),
    Withe(
        hex = "#ffffff",
        rgb = rgb(r = 255, g = 255, b = 255)
    ),
    Black(
        hex = "#000000",
        rgb = rgb(r = 0, g = 0, b = 0)
    ),
//    Primary(
//        hex = "#000000",
//        rgb = rgb(0, 0, 0)
//    ),
//    Secondary(
//        hex = "#000000",
//        rgb = rgb(r = 0, g = 0, b = 0)
//    ),
    Primary(
        hex = "#8204ff",
        rgb = rgb(130, 4, 255)
    ),
    Secondary(
        hex = "#b9468b",
        rgb = rgb(r = 185, g = 70, b = 139)
    ),
    Tertiary(
        hex = "#b9468b",
        rgb = rgb(r = 193, g = 15, b = 255)
    ),
    LightBlue(
        hex = "#8204ff",
        rgb = rgba(0, 122, 255,0.1)
    ),

    Yellow(
        hex = "#ffcd57",
        rgb = rgb(r = 255, g = 205, b = 87)
    ),
    Blue( //#0d6efd
        hex = "#0d6efd",
        rgb = rgb(r = 13, g = 110, b = 253)
    ),
    GoogleBlue(
        hex = "#4285F4" ,
        rgb = rgb(r = 37, g = 99, b = 235)
    ),
    GoogleBlueDark(
        hex = "#1565C0" ,
        rgb = rgb(r = 21, g = 101, b = 192)
    ),

    Green(
        hex = "#2ecc40",
        rgb = rgb(r = 46, g = 236, b = 64)

    ),
    LightGreen(
        hex = "#F1F8E9CC",
        rgb = rgba(r = 46, g = 236, b = 64,0.8)
    ),

    Red(
        hex = "#e74c3c",
        rgb = rgb(r = 231, g = 76, b = 60)
    ),
    Orange(
        hex = "#f1c40f",
        rgb = rgb(r = 241, g = 196, b = 15)
    ),
    Transparent(
        hex = "#00000000" ,
        rgb = rgba(0, 0, 0, 0)
    )

}


